<template>
  <div class="cart-goods-list">
    <div ref="sentinel" class="sticky-sentinel"></div>
    <div class="sticky-header" :class="{ 'is-stuck': isStuck }">
      <Search ref="goodsSearch" :activeName="activeTab" @search="handleSearch" />
      <div class="filter-wrap">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane v-for="item in tabData" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
        </el-tabs>
        <div class="filter-bar">
          <div v-if="!isTaobaoImageSearch" class="sort-item-wrap">
            <div v-for="item in sortItemData" :key="item.value" class="sort-item"
              :class="{ 'sort-item-active': query.sortKey === item.value }" @click="sortKey(item)">
              <span>{{ item.label }}</span>
              <span v-if="item.hasIcon" class="sort-icon">
                <span class="sort-icon-up"
                  :class="{ 'sort-icon-up-active': query.sortKey === item.value && query.sort === 'asc' }"></span>
                <span class="sort-icon-bottom"
                  :class="{ 'sort-icon-bottom-active': query.sortKey === item.value && query.sort === 'desc' }"></span>
              </span>
            </div>
          </div>
          <div class="filter-form">
            <div v-if="!isTaobaoImageSearch" class="filter-form-item">
              <span class="filter-form-label">{{ $t("cart.wslang190") }}：</span>
              <el-input size="mini" v-model="query.lowPrice"></el-input>
              <span>-</span>
              <el-input size="mini" v-model="query.highPrice"></el-input>
            </div>
            <div class="filter-form-item">
              <span class="filter-form-label">{{ $t("cart.wslang1171") }}：</span>
              <el-select size="mini" v-model="query.shipIn">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

          </div>
          <div class="filter-btn">
            <el-button size="mini" class="search-btn btn-blue" @click="handleFilterSearch">{{ $t("query") }}</el-button>
            <el-button size="mini" class="search-btn btn-gray" @click="onReset">{{ $t("reset") }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="goods-list-container">
      <div class="goods-list-item" v-for="item in goodsList" :key="item.numId" @click="goDetail(item)">
        <!-- <div class="goods-same-search" @click.stop="handleSameSearch"><span>{{ $t('cart.wslang1276') }}</span></div> -->
        <div class="goods-image">
          <el-image :src="item.picPath" fit="contain" />
        </div>
        <div class="goods-title">
          <el-image v-if="activeTab === '1688'" class="goods-tag" :src="img1688" fit="contain" />
          <el-image v-if="activeTab === 'taobao'" class="goods-tag" :src="imgTb" fit="contain" />
          <!-- <el-image v-if="activeTab === 'jd'" class="goods-tag" :src="imgJd" fit="contain" /> -->
          <span class="text-row-2">{{ item.goodsName }}</span>
        </div>
        <div v-if="item.repurchaseRate" class="goods-sales-info">
          <div class="goods-sales-info-item">
            {{ $t('cart.wslang1166') }}:
            <span class="num-value" style="color: #FF691F;margin-left: 5px;">
              {{ item.monthSold }}
            </span>
          </div>
          <div class="goods-sales-info-item">
            {{ $t('cart.wslang1167') }}:
            <span class="num-value" style="color: #FF691F;margin-left: 5px;">
              {{ item.repurchaseRate }}
            </span>
          </div>
        </div>
        <div class="goods-price">
          <span class="price-num">{{ `${formatPrice(item.goodsPrice)}${$t("cart.wslang488")}` }}</span>
        </div>
      </div>
    </div>
    <el-pagination class="lx-page-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="page.pageNum" :page-sizes="pageSizes" :page-size="page.pageSize" :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
  </div>
</template>

<script>
import Search from './search.vue'
import { formatPrice } from "@/utils/utils";
import img1688 from '@/assets/images/1688.png'
import imgTb from '@/assets/images/tb.png'
import imgJd from '@/assets/images/jd.png'
export default {
  components: {
    Search
  },
  data() {
    return {
      tabData: [
        { label: '1688', value: '1688' },
        // 暂时隐藏淘宝天猫入口，保留后续恢复所需代码
        // { label: this.$t('cart.cart32'), value: 'taobao' },
      ],
      activeTab: "1688",
      sortItemData: [
        { label: this.$t("cart.wslang531"), value: 1 },
        { label: this.$t("cart.wslang441"), value: 2, hasIcon: true },
        { label: this.$t("cart.wslang189"), value: 3, hasIcon: true },
      ],
      apiUrl: "shop/1688/goods/queryGoodsList",
      query: {
        sortKey: 1,
        sort: undefined,
        lowPrice: "",
        highPrice: "",
        shipIn: "",
        keyName: "",
        goodsName: "",
        imgId: ""
      },
      page: {
        pageSize: 50,
        pageNum: 1
      },
      total: 0,
      goodsList: [],
      options: [
        {
          value: '0',
          label: this.$t('cart.wslang1172')
        },
        {
          value: '1',
          label: this.$t('cart.wslang1173')
        },
        {
          value: '2',
          label: this.$t('cart.wslang1174')
        }
      ],
      newState: {
        rate: 24.67
      },
      isStuck: false,
      img1688,
      imgTb,
      imgJd,
      formatPrice
    };
  },
  computed: {
    isTaobaoImageSearch() {
      return this.activeTab === 'taobao' && !!this.query.imgId
    },
    pageSizes() {
      return this.activeTab === 'taobao'
        ? [5, 10, 20]
        : [5, 10, 20, 50, 100, 200]
    }
  },
  watch: {
    '$route'(to) {
      const { keywords, imgId, platform } = to.query
      this.query.keyName = keywords || ''
      this.query.goodsName = keywords || ''
      this.query.imgId = imgId || ''
      if (imgId) {
        this.activeTab = platform || '1688'
        this.apiUrl = platform === 'taobao'
          ? 'taobaoShop/queryGoodsListByImage'
          : 'shop/1688/goods/queryGoodsListBy1688Img'
      } else {
        this.activeTab = platform || '1688'
        this.apiUrl = platform === 'taobao'
          ? 'taobaoShop/queryGoodsListByKeyWord'
          : 'shop/1688/goods/queryGoodsList'
      }
      this.syncPageSize()
      this.page.pageNum = 1
      this.getList()
    }
  },
  mounted() {
    this._observer = new IntersectionObserver(
      ([entry]) => { this.isStuck = !entry.isIntersecting; },
      { threshold: 0 }
    );
    this._observer.observe(this.$refs.sentinel);
    const { keywords, imgId, platform } = this.$route.query
    this.query.keyName = keywords
    this.query.goodsName = keywords
    this.query.imgId = imgId
    this.activeTab = platform || "1688"
    this.syncPageSize()
    if (imgId) {
      this.apiUrl = platform === 'taobao'
        ? 'taobaoShop/queryGoodsListByImage'
        : 'shop/1688/goods/queryGoodsListBy1688Img'
    } else {
      this.apiUrl = platform === 'taobao'
        ? 'taobaoShop/queryGoodsListByKeyWord'
        : 'shop/1688/goods/queryGoodsList'
    }
    this.getList();
  },
  beforeDestroy() {
    this._observer && this._observer.disconnect();
  },
  methods: {
    sortKey(sortItem) {
      this.query.sortKey = sortItem.value;
      if (sortItem.hasIcon) {
        if (this.query.sortKey === sortItem.value) {
          if (this.query.sort) {
            this.query.sort = this.query.sort === 'asc' ? 'desc' : 'asc';
          } else {
            this.query.sort = 'asc'
          }
        } else {
          this.query.sort = undefined;
        }
      }
      this.getList();
    },
    handleSearch() {
      this.page.pageNum = 1
    },
    handleFilterSearch() {
      this.page.pageNum = 1
      this.getList()
    },
    async handleTabClick(tab) {
      const currentImgId = this.query.imgId || this.$route.query.imgId;
      const isImageSearch = !!currentImgId;
      if (tab.name === "taobao") {
        this.apiUrl = isImageSearch
          ? "taobaoShop/queryGoodsListByImage"
          : "taobaoShop/queryGoodsListByKeyWord"
      } else {
        this.apiUrl = isImageSearch
          ? "shop/1688/goods/queryGoodsListBy1688Img"
          : "shop/1688/goods/queryGoodsList"
      }
      if (isImageSearch) {
        const imgId = await this.$refs.goodsSearch.switchImagePlatform(tab.name)
        if (!imgId) {
          // 刷新后没有原始图片文件时，切换为当前平台的普通关键词搜索。
          this.query.imgId = ''
          this.apiUrl = tab.name === 'taobao'
            ? 'taobaoShop/queryGoodsListByKeyWord'
            : 'shop/1688/goods/queryGoodsList'
        } else {
          this.query.imgId = imgId
        }
      }
      this.page.pageNum = 1
      this.syncPageSize()
      this.updatePlatformQuery(tab.name, this.query.imgId)
    },
    updatePlatformQuery(platform, imgId) {
      const query = {
        ...this.$route.query,
        platform
      }
      if (imgId) {
        query.imgId = encodeURI(imgId)
      } else {
        delete query.imgId
      }
      this.$router.replace({
        name: 'cartDetail',
        query
      }).catch(() => {})
    },
    syncPageSize() {
      if (this.activeTab === 'taobao' && this.page.pageSize > 20) {
        this.page.pageSize = 20
      }
    },
    async getList() {
      const params = {
        ...this.page,
        ...this.query,
        imageId: this.query.imgId,
        platform: this.activeTab
      }
      const res = await this.$http.get(this.apiUrl, { params });
      if (res.data.code === 200) {
        const { list, total } = res.data.data
        this.goodsList = list
        this.total = total
      }
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.page.pageNum = page;
      this.getList();
    },
    onReset() {
      this.query.highPrice = ''
      this.query.lowPrice = ''
      this.query.shipIn = undefined
    },
    goDetail(item) {
      console.log('goDetail item.goodsUrl:', item.goodsUrl)
      this.$router.push({
        name: 'goodsDetail',
        query: {
          goodsUrl: item.goodsUrl
        },
      });
    },
    handleSameSearch() {
      console.log('sameSearch')
    }
  }
};
</script>
<style lang="less" scoped>
.cart-goods-list {
  overflow-y: auto;
  height: 100%;

  .sticky-sentinel {
    height: 0;
    visibility: hidden;
  }

  .sticky-header {
    position: sticky;
    top: 0px;
    z-index: 100;
    background: transparent;
    transition: 0.2s ease;

    &.is-stuck {
      background-color: var(--bg-card);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: inherit;
      z-index: -1;
    }

    .filter-wrap {
      background-color: var(--bg-card);
      padding: 10px;
      padding-top: 0;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;

      .filter-bar {
        display: flex;
        align-items: center;
        gap: 30px;
        margin-bottom: 10px;

        .sort-item-wrap {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .sort-item {
          display: flex;
          cursor: pointer;
          user-select: none;

          &:hover {
            color: #1481d1;
          }

          &-active {
            color: #1481d1;
          }

          .sort-icon {
            display: flex;
            flex-direction: column;
            margin-left: 2px;
            justify-content: center;
            align-items: center;
            gap: 2px;
            margin-top: 1px;

            .sort-icon-bottom {
              border-top: 4px solid;
              border-color: #ccc #0000 #0000;
              border-style: solid;
              border-width: 5px 4px 0;

              &-active {
                border-color: #1481d1 #0000 #0000;
              }
            }

            .sort-icon-up {
              border-top: 4px solid;
              border-color: #0000 #0000 #ccc;
              border-style: solid;
              border-width: 0 4px 5px;

              &-active {
                border-color: #0000 #0000 #1481d1;
              }
            }
          }
        }

        .filter-form {
          display: flex;
          align-items: center;
          gap: 20px;

          .filter-form-item {
            display: flex;
            align-items: center;
            gap: 4px;

            :deep(.el-input) {
              max-width: 100px;
            }

            :deep(.el-select) {
              max-width: 120px;

              .el-input {
                max-width: 100%;
              }
            }
          }
        }
      }
    }
  }

  .goods-list-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: var(--bg-card);
    padding: 10px;
    padding-top: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    .goods-list-item,
    .goods-list-item-mobile {
      border: 1px solid var(--border);
      margin-right: 11px;
      margin-bottom: 20px;
      width: 222px;
      border-radius: 12px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      transition: .3s ease;
      padding-bottom: 10px;

      &:hover {
        box-shadow: 0 4px 16px 0 #0000001a;
        transform: translateY(-4px);
        // box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6), 
        //         0 4px 10px rgba(255, 255, 255, 0.05); 
      }

      .goods-same-search {
        position: absolute;
        height: 24px;
        padding: 0 10px;
        box-shadow: 0px 0px 10px 0px gainsboro;
        background: #ffffff;
        border-radius: 20px;
        z-index: 10;
        font-size: 12px;
        color: #31c643;
        left: 10px;
        margin: 5px 5px 0 0;
      }

      .goods-title {
        width: 170px;
        height: 44px;
        margin: 0 auto;
        font-size: 14px;
        color: var(--text-main);
        position: relative;
      }

      .goods-image {
        margin: auto;
        height: 190px;
        box-sizing: content-box;
        overflow: hidden;
        transition: .3s ease;

        &:hover {
          transform: scale(1.05);
        }
      }

      .goods-tag {
        position: absolute;
        top: -2px;
        left: -26px;
        width: 25px;
        height: 25px;
      }

      .goods-sales-info,
      .goods-price {
        width: 170px;
        padding: 0;
        color: var(--text-main);
        margin: auto;
        margin-top: 4px;
      }

      .goods-sales-info {
        .goods-sales-info-item {
          font-size: 12px;

          .num-value {
            font-size: 12px;
            color: #FF691F;
          }
        }
      }

      .goods-price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 8px;

        .price-num {
          color: #ff691f;
          font-weight: bold;
        }
      }
    }
  }

  .lx-page-pagination {
    text-align: center !important;
  }
}

@media screen and (max-width: 768px) {
  .cart-goods-list {
    .sticky-header {
      .filter-wrap {
        .filter-bar {
          flex-wrap: wrap;
          gap: 10px;

          .filter-form {
            flex-wrap: wrap;
            gap: 10px;

            .filter-form-item {
              width: 100%;
            }
          }
        }
      }
    }

    .goods-list-container {
      .goods-list-item-mobile {
        display: flex;
        width: 100%;
        margin-right: 0;
        padding: 4px;
        gap: 10px;
        overflow: unset;

        .goods-same-search {
          height: 18px;
          padding: 0 5px;
          font-size: 10px;
          left: -7px;
          top: 0px;
          margin: 0;
        }

        .goods-image {
          width: 100px;
          height: 100px;
        }

        .goods-right-info {
          flex: 1;

          .goods-title,
          .goods-sales-info,
          .goods-price {
            width: 100%;

            .text-row-2 {
              margin-top: 0;
            }
          }

          .goods-price {
            .price-num {
              display: flex;
              align-items: center;
              gap: 5px;
            }

            .goods-tag {
              position: unset;
              margin-top: 1px;
            }
          }
        }
      }
    }
  }
}
</style>
